"use client";
import {createContext, useCallback, useContext, useEffect, useMemo, useState,} from "react";

const CustomerContext = createContext(null);

export function CustomerProvider({ children }) {
    const [customer, setCustomer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [orders, setOrders] = useState([]);
    const [addresses, setAddresses] = useState([]);
    const hydrateCustomer = useCallback(async () => {
            try {
                setLoading(true)
                const response = await fetch('/api/customer/me')
                const data = await response.json()
                const customerData = data.customer || null
                setCustomer(customerData)
                if (!customerData) {
                    setAddresses([])
                    setOrders([])
                    return null
                }
                const [addressRes, orderRes,] = await Promise.all([
                    fetch('/api/customer/addresses'),
                    fetch('/api/customer/orders'),
                ])
                const [addressData, orderData,] = await Promise.all([addressRes.json(), orderRes.json(),])
                setAddresses(addressData?.addresses || [])
                setOrders(orderData.orders || [])
                return customerData
            } catch (err) {
                console.log(err)
                setError(err?.message || 'Something went wrong')
            } finally {
                setLoading(false)
            }
        }, [])

    /* eslint-disable react-hooks/set-state-in-effect */
    useEffect(() => {
        hydrateCustomer()
    }, [hydrateCustomer])
    /* eslint-enable react-hooks/set-state-in-effect */

    const refreshCustomer =
        useCallback(async () => {
            return await hydrateCustomer()
        }, [hydrateCustomer])

    const logout = useCallback(
        async () => {
            await fetch('/api/customer/logout', {
                method: 'POST',
                })
            setCustomer(null)
            setAddresses([])
            setOrders([])
        }, []
    )

    const value = useMemo(()=>({
        customer,
        addresses,
        orders,
        setCustomer,
        loading,
        refreshCustomer,
        logout

    }),[
        customer,
        addresses,
        orders,
        loading,
        refreshCustomer,
        logout,
    ])

    return (
        <CustomerContext.Provider value={value}>{children}</CustomerContext.Provider>
    )
}

export function useCustomer(){
    return useContext(CustomerContext)
}